<template>
  <span
    class="v-switch"
    :class="{'v-switch-on': me_checked, 'v-switch-disabled': disabled}"
    :value="value"
    @click="toggle"
  />
</template>

<script>
export default {
  name: 'VSwitch',
  props: {
    value: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    changeNow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      me_checked: this.value
    }
  },
  watch: {
    value(val) {
      this.me_checked = val
    }
  },
  methods: {
    toggle() {
      if (this.disabled) {
        return null
      } else if (!this.changeNow) {
        this.$emit('switch')
      } else {
        this.me_checked = !this.me_checked
        this.$emit('switch', this.me_checked)
      }
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.v-switch {
  position: relative;
  display: block;
  width: 24/@rem;
  height: 14/@rem;
  box-sizing: border-box;
  border: 1px solid @major;
  border-radius: 16/@rem;
  background-color: transparent;
  cursor: pointer;
  outline: 0;
  transition: background-color 0.1s, border 0.1s;
}

.v-switch::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 22/@rem;
  height: 12/@rem;
  border-radius: 11/@rem;
  background-color: transparent;
  content: " ";
  transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
}

.v-switch::after {
  position: absolute;
  top: 50%;
  left: 1px;
  width: 10/@rem;
  height: 10/@rem;
  border-radius: 50%;
  margin-top: -5/@rem;
  background-color: @major;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 40%);
  content: " ";
  transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
}

.v-switch-on {
  border-color: @major;
  background-color: @primary;
}

.v-switch-on::before {
  border-color: @major;
  background-color: @primary;
}

.v-switch-on::after {
  left: 0/@rem;
  transform: translateX(11/@rem);
}

.v-switch-disabled {
  border: 1px solid @normal;
}

.v-switch-disabled::before {
  background-color: @gray;
}

.v-switch-disabled::after {
  background-color: @normal;
}
</style>
